/* eslint-disable max-len */
import { createSelector } from "reselect";
import get from "lodash/get";
import { getIsMultiPartnerJourney, getSignatories } from "./appConfig";

export const getStakeholdersState = state => state.stakeholders;

export const getEditableStakeholder = state => getStakeholdersState(state).editableStakeholder;

export const getStakeholdersIds = state => getStakeholdersState(state).stakeholdersIds;

export const getStakeholders = createSelector(
  getSignatories,
  getStakeholdersIds,
  (stakeholders, stakeholdersIds) =>
    stakeholders.map((item, index) => ({
      ...item,
      id: stakeholdersIds[index]
    }))
);

export const getPercentage = state => {
  const stakeholdersList = getSignatories(state);
  return stakeholdersList.reduce(
    (previousValue, currentValue) =>
      previousValue + Number(get(currentValue, "kycDetails.shareHoldingPercentage", 0)),
    0
  );
};

export const getPercentageWithoutCurrentStakeholder = (state, index) => {
  const signatories = [...getSignatories(state)];
  signatories.splice(index, 1);

  return signatories.reduce(
    (acc, item) => acc + Number(get(item, "kycDetails.shareHoldingPercentage", 0)),
    0
  );
};

export const checkIsHasSignatories = state =>
  getStakeholders(state).some(stakeholder => get(stakeholder, "kycDetails.isSignatory"));

export const getSelectedStakeholderId = state => getStakeholdersState(state)?.selectedSignatoryId;

export const getSelectedSignatoryIndex = state => {
  const selectedSignatoryId = getSelectedStakeholderId(state);
  const isMultiPartnerJourney = getIsMultiPartnerJourney(state);
  const signatoryIndex = getSignatories(state).findIndex(
    eachItem => eachItem.signatoryId === selectedSignatoryId
  );
  return isMultiPartnerJourney ? signatoryIndex : 0;
};

export const getSelectedStakeholder = state => {
  const selectedSignatoryIndex = getSelectedSignatoryIndex(state);
  const signatoryList = getSignatories(state);
  return signatoryList[selectedSignatoryIndex];
};

export const checkIsSelectedStakeholderSignatory = state => {
  const selectedSignatoryIndex = getSelectedSignatoryIndex(state);
  const signatoryList = getSignatories(state);
  return !!signatoryList[selectedSignatoryIndex]?.kycDetails?.isSignatory;
};

export const getStakeholderStatusType = state => getStakeholdersState(state).stakeholderStatusType;

export const getIsMultipleSignatoriesJourney = state =>
  getStakeholdersState(state).isMultipleSignatoriesJourney;

export const getIsPrimaryContact = state => {
  const selectedStakeholder = getSelectedStakeholder(state);
  return selectedStakeholder?.kycDetails?.isPrimaryContact;
};
